export const SOUND_KEYS = [
  'tap',
  'correct',
  'wrong',
  'coin',
  'sessionStart',
  'sessionEnd',
  'levelUp',
  'rankUp',
] as const;

export type SoundKey = (typeof SOUND_KEYS)[number];

export interface SoundSpec {
  src: string[];
  volume: number;
  /** Опис для того, хто колись згенерує/запише файл. */
  purpose: string;
}

/**
 * Реєстр звуків. Файли лежать у `apps/web/public/sounds`.
 *
 * Згенеровані через ElevenLabs і зведені в один рівень: обрізана тиша з обох
 * боків, пік −1 dBFS, моно 56 кбіт/с. Гучність кожного звуку задається ТУТ,
 * а не в файлі, — тому файли мусять приходити однаково гучними, інакше «клац»
 * перекрикував би «монету». Скрипт зведення: scripts/generate-sounds.sh.
 *
 * Тихий фолбек лишається: якщо файл колись зникне, менеджер це проковтне і
 * застосунок працюватиме без звуку (див. sound.ts).
 */
export const SOUNDS: Record<SoundKey, SoundSpec> = {
  tap: { src: ['/sounds/tap.mp3'], volume: 0.35, purpose: 'Короткий клац по кнопці' },
  correct: { src: ['/sounds/correct.mp3'], volume: 0.7, purpose: 'Правильна відповідь' },
  wrong: { src: ['/sounds/wrong.mp3'], volume: 0.55, purpose: 'Помилка' },
  coin: { src: ['/sounds/coin.mp3'], volume: 0.6, purpose: 'Дзвін монети' },
  sessionStart: { src: ['/sounds/session-start.mp3'], volume: 0.6, purpose: 'Старт сесії' },
  sessionEnd: { src: ['/sounds/session-end.mp3'], volume: 0.6, purpose: 'Підсумок сесії' },
  levelUp: { src: ['/sounds/level-up.mp3'], volume: 0.7, purpose: 'Зростання навички' },
  rankUp: { src: ['/sounds/rank-up.mp3'], volume: 0.8, purpose: 'Підвищення рангу' },
};
